<template>
  <loader v-if="fetchResumeItemPending"/>
  <v-container v-else>
    <v-row>
      <v-col :cols="12">
        <div class="d-flex align-center">
          <v-btn text icon @click="() => $router.go(-1)">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <h1>
            {{ form.id > 0 ? $t('texts.editOtherDocument') : $t('texts.addOtherDocument') }}
          </h1>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-form>
              <v-container grid-list-xl class="pa-0">
                <v-row>
                  <v-col :cols="12" :md="12">
                    <v-text-field
                      :label="$t('texts.nameOfDocument')"
                      v-model="form.title"
                      required
                      :error-messages="errors.collect('title')"
                      v-validate="'required'"
                      data-vv-name="title"
                      :data-vv-as="$t('texts.nameOfDocument')"
                    />
                  </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                  <v-col :cols="12">
                    <file-upload
                      :documents="form.documents"
                      @interface="editedDocuments"
                      :uploadType="`certificationsUpload-${form.id}`"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-divider/>
          <v-card-actions class="py-3 px-5">
            <v-btn
              color="red darken-2"
              v-if="form.id > 0"
              class="white--text"
              @click="deleteItem()"
              :disabled="storeResumeItemPending || deleteResumeItemPending"
              :loading="deleteResumeItemPending"
            >
              {{ $t('texts.deleteEntry') }}
              <v-icon right class="white--text">delete</v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn
              color="primary" class="white--text"
              @click="handleFormSubmit()"
              :disabled="storeResumeItemPending || deleteResumeItemPending"
              :loading="storeResumeItemPending"
            >
              {{ form.id > 0 ? $t('texts.saveChanges') : $t('texts.save') }}
              <v-icon right class="white--text">check_circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirmation-dialog ref="confirm"/>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import FileUpload from '@/components/_organisms/FileUpload.vue';
import ConfirmationDialog from '@/components/_organisms/ConfirmationDialog.vue';

const { mapState: mapEmployeeState, mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'EditResumeCertification',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    FileUpload,
    ConfirmationDialog,
  },
  data() {
    return {
      form: {
        id: null,
        title: '',
        documents: [],
      },
      documents: [],
    };
  },
  created() {
    this.reset();
    if (this.$route.params.item) {
      Object.assign(this.form, this.$route.params.item);
    } else if (this.$route.params.id) {
      const payload = {
        type: this.$route.meta.resumeType,
        id: this.$route.params.id,
      };
      this.fetchResumeItem(payload).then((response) => {
        Object.assign(this.form, response.data.data);
      });
    }
  },
  computed: {
    ...mapEmployeeState([
      'fetchResumeItemPending',
      'storeResumeItemPending',
      'deleteResumeItemPending',
    ]),
  },
  methods: {
    ...mapEmployeeActions([
      'fetchResumeItem',
      'storeResumeItem',
      'deleteResumeItem',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    reset() {
      this.form = {
        title: '',
        documents: [],
      };
      this.$validator.reset();
    },
    editedDocuments(editedDocuments) {
      this.form.documents = editedDocuments;
    },
    handleFormSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const payload = {
            type: 'certifications',
            item: this.form,
            successMessageKey: this.form.id ? 'alert.updateEntrySuccessful' : 'alert.addResumeOtherDocumentsSuccessful',
            errorMessageKey: this.form.id ? 'alert.updateEntryError' : 'alert.addResumeOtherDocumentsError',
          };
          this.storeResumeItem(payload)
            .then(() => {
              this.$router.go(-1);
              this.$eventBus.$emit('clear-file-upload');
            });
        } else {
          this.showMessageValidateError();
        }
      });
    },
    async deleteItem() {
      const confirmDialog = async () => this.$refs.confirm.open({
        title: 'deleteEntry',
        message: 'deleteEntryQuestion',
        confirm: 'delete',
        reject: 'cancel',
      });
      if (await confirmDialog()) {
        const payload = {
          type: 'certifications',
          item: this.form,
        };
        this.deleteResumeItem(payload)
          .then(() => {
            this.$router.go(-1);
          });
      }
    },
  },
};
</script>
